export class ConstantUtils {

  constructor() {
  }
  public static CURRENT_YEAR_ID = 'currentAcademicYear';
  public static BOOTSTRAP = 'bootstrap';
  public static SOURCE_FROM = 'sourceFrom';
  public static FEEDBACK = 'feedback';
  public static FEENOTPAID = 'feeNotPaid';
  public static STUDENT_LIST = 'studentList';
  public static STAFF_LIST = 'staffList';
  public static NON_TEACHING_STAFF_LIST = 'nonTeachingStaffList';
  public static STUDENT_BIRTHDAY = 'studentBirthday';
  public static STAFF_BIRTHDAY = 'staffBirthday';
  public static GROUP_ADD_DATA = 'GroupAdd';
  public static GROUP_EDIT_DATA = 'GroupEdit';
  public static QUES_FROM_CHAPTER = 'Chapter';
  public static QUES_FROM_RESULT = 'ObjResult';
  public static ADMIN = 'admin';
  public static ENQUIRY = 'enquiry';
  public static STUDENT_VIEW = 'VIEW';
  public static STUDENT_EDIT = 'EDIT';
  public static TRANSPORT_FEES = 'transport_fees';
  public static boys = 'boys';
  public static girls = 'girls';
  public static all = 'all';
  public static male = 'male';
  public static female = 'female';
  public static TIMETABLE_CONFIG_CLASS = 'TIMETABLE_CONFIG_CLASS'
}
